import { TYPES } from "./task_effort.type";
import {
  getCountFromServer,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  startAfter,
  where,
  getAggregateFromServer,
  sum,
} from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getAuth } from "firebase/auth";
import { getApp } from "firebase/app";

const app = getApp();
const auth = getAuth(app);

//snap all provider
const allTaskEffortSub = [];
export const snapTaskEffort = (callback) => (dispatch) => {
  setTaskEffortAllSuccess(dispatch, null);
  const cRef = getRefs().effort;
  const uid = getAuth()?.currentUser?.uid;
  console.log("trigger snap task efforts");
  const c0 = where("supporterId", "==", uid);
  const qRef = query(cRef, c0);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      console.log({ data });
      setTaskEffortAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allTaskEffortSub.push(unsub);
};

export const unSnapTaskEffort = () => (dispatch) => {
  allTaskEffortSub.forEach((subscriber) => {
    subscriber();
  });
  allTaskEffortSub.length = 0;
};

// get page.
export const getTop10TaskEffort =
  ({ tab }, callback) =>
  (dispatch) => {
    setTaskEffortAllSuccess(dispatch, null);
    const cRef = getRefs().effort;
    const uid = auth?.currentUser?.uid;
    const c0 = where("supporterId", "==", uid);
    const c1 = where("rate", "==", tab);
    const c2 = orderBy("createAt", "desc");
    const c3 = limit(10);
    const qRef = query(cRef, c0, c1, c2, c3);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs.map((doc) => doc.data());
        setTaskEffortAllSuccess(dispatch, data);
      }
    });
  };

// get task effort per page.
export const getTaskEfforPerPage =
  ({ page, tab }, callback) =>
  async (dispatch) => {
    setTaskEffortAllSuccess(dispatch, null);
    const cRef = getRefs().effort;
    const uid = auth?.currentUser?.uid;
    const lastPage = (page - 1) * 10;
    const c0 = where("supporterId", "==", uid);
    const c1 = where("rate", "==", tab);
    const c2 = orderBy("createAt", "desc");
    const c3 = limit(lastPage);
    const qRef0 = query(cRef, c0, c1, c2, c3);
    const snapshot0 = await getDocs(qRef0);
    const last = snapshot0?.docs?.[snapshot0?.docs?.length - 1];

    // get 10 page per page.
    const c4 = startAfter(last);
    const c5 = limit(10);
    const qRef = query(cRef, c0, c1, c2, c4, c5);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs?.map((doc) => doc?.data());
        setTaskEffortAllSuccess(dispatch, data);
      }
    });
  };

// đếm tổng
export const countTaskEffortIndice = (callback) => async (dispatch) => {
  // pass.
  const pass = await countTaskEffortByField({ tab: "pass" });
  setTaskEffortCountPassSuccess(dispatch, pass);

  // warn
  const warn = await countTaskEffortByField({ tab: "warn" });
  setTaskEffortCountWarnSuccess(dispatch, warn);

  // deny.
  const deny = await countTaskEffortByField({ tab: "deny" });
  console.log({ deny });
  setTaskEffortCountDenySuccess(dispatch, deny);
};

// đếm số trang.
export const countTaskEffortByField = async ({ tab }) => {
  const cRef = getRefs().effort;
  const uid = auth?.currentUser?.uid;
  const c0 = where("supporterId", "==", uid);
  const c1 = where("rate", "==", tab);
  const qRef = query(cRef, c0, c1);
  const snapshot = await getCountFromServer(qRef);
  const count = snapshot?.data().count || 0;
  return count;
};

// tổng số exp.
export const sumTaskEffortIndice = (callback) => async (dispatch) => {
  // tính cho exp.
  const exp = await calculateSumField({ field: "exp" });
  setTaskEffortSumExpSuccess(dispatch, exp);

  // tính cho effort.
  const effort = await calculateSumField({ field: "effort" });
  setTaskEffortSumEffortSuccess(dispatch, effort);

  // tính cho ease.
  const ease = await calculateSumField({ field: "ease" });
  setTaskEffortSumEaseSuccess(dispatch, ease);

  // tính cho mistake.
  const mistake = await calculateSumField({ field: "mistake" });
  setTaskEffortSumMisTakeSuccess(dispatch, mistake);
};

// tính tổng hàm.
const calculateSumField = async ({ field }) => {
  const cRef = getRefs().effort;
  const uid = auth?.currentUser?.uid;
  const c0 = where("supporterId", "==", uid);
  const q = query(cRef, c0);
  const snapshot = await getAggregateFromServer(q, {
    [field]: sum(field), //
  });

  const sumTotal = snapshot.data()?.[field] || 0;
  return sumTotal;
};

// ========= cloud function =========//
// ========= local function =========//
export const setTaskEffortAll = (data, callback) => (dispatch) => {
  setTaskEffortAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setTaskEffortOpenAdd = (data, callback) => (dispatch) => {
  setTaskEffortOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setTaskEffortOpenEdit = (data, callback) => (dispatch) => {
  setTaskEffortOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setTaskEffortSelected = (data, callback) => (dispatch) => {
  setTaskEffortSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setTaskEffortSearch = (data, callback) => (dispatch) => {
  setTaskEffortSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setTaskEffortAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_ALL,
    payload: data,
  });
};

const setTaskEffortOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_OPEN_ADD,
    payload: data,
  });
};

const setTaskEffortOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_OPEN_EDIT,
    payload: data,
  });
};

const setTaskEffortSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_SELECTED,
    payload: data,
  });
};

const setTaskEffortSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_SEARCH,
    payload: data,
  });
};

const setTaskEffortCountPassSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_COUNT_PASS,
    payload: data,
  });
};

const setTaskEffortCountWarnSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_COUNT_WARN,
    payload: data,
  });
};

const setTaskEffortCountDenySuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_COUNT_DENY,
    payload: data,
  });
};

const setTaskEffortSumExpSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_SUM_EXP,
    payload: data,
  });
};

const setTaskEffortSumEffortSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_SUM_EFFORT,
    payload: data,
  });
};

const setTaskEffortSumEaseSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_SUM_EASE,
    payload: data,
  });
};

const setTaskEffortSumMisTakeSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_TASK_EFFORT_SUM_MISTAKE,
    payload: data,
  });
};
